var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87299 11.2295C5.99707 11.2295 5.287 11.945 5.287 12.8277C5.287 13.7103 5.99707 14.4258 6.87299 14.4258C7.74891 14.4258 8.45898 13.7103 8.45898 12.8277C8.45898 11.945 7.74891 11.2295 6.87299 11.2295Z",
    fill: "#9BACEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87299 5.9014C5.99707 5.9014 5.287 6.61691 5.287 7.49953C5.287 8.38215 5.99707 9.09766 6.87299 9.09766C7.74891 9.09766 8.45898 8.38215 8.45898 7.49953C8.45898 6.61691 7.74891 5.9014 6.87299 5.9014Z",
    fill: "#9BACEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58637 11.2295C0.710449 11.2295 0.000375056 11.945 0.000375132 12.8277C0.000375209 13.7103 0.710449 14.4258 1.58637 14.4258C2.46229 14.4258 3.17236 13.7103 3.17236 12.8277C3.17236 11.945 2.46229 11.2295 1.58637 11.2295Z",
    fill: "#9BACEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58637 5.9014C0.710449 5.9014 0.000375056 6.61691 0.000375133 7.49953C0.000375209 8.38215 0.710449 9.09766 1.58637 9.09766C2.46229 9.09766 3.17236 8.38215 3.17236 7.49953C3.17236 6.61691 2.46229 5.9014 1.58637 5.9014Z",
    fill: "#9BACEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58637 0.574254C0.710449 0.574254 0.000375056 1.28976 0.000375133 2.17238C0.000375209 3.055 0.710449 3.77051 1.58637 3.77051C2.46229 3.77051 3.17236 3.055 3.17236 2.17238C3.17236 1.28976 2.46229 0.574254 1.58637 0.574254Z",
    fill: "#9BACEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87299 0.574254C5.99707 0.574254 5.287 1.28976 5.287 2.17238C5.287 3.055 5.99707 3.77051 6.87299 3.77051C7.74891 3.77051 8.45898 3.055 8.45898 2.17238C8.45898 1.28976 7.74891 0.574254 6.87299 0.574254Z",
    fill: "#9BACEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/DragIcon.8420970a.svg";
export { ForwardRef as ReactComponent };